module.exports = __webpack_public_path__ + "img/ericPic.58be4b54.jpeg";